import {orgHovercardPath} from '@github-ui/paths'

import {
  type BaseHovercardOptions,
  type HovercardAttributesResult,
  buildHovercardAttributes,
  useHovercardAttributesBase,
} from './shared'

export type OrganizationHovercardOptions = BaseHovercardOptions & {
  login: string | undefined
}

/**
 * Generate hovercard attributes for an organization.
 */
function organizationHovercardAttributes(options: OrganizationHovercardOptions): HovercardAttributesResult {
  if (!options.login) return {}

  const url = orgHovercardPath({owner: options.login})
  return buildHovercardAttributes(url, 'organization', options.tracking ?? true)
}

/**
 * React hook for organization hovercard attributes.
 *
 * @example
 * ```tsx
 * function OrgLink({ login }: { login: string }) {
 *   const hovercardAttrs = useHovercardAttributesForOrganization({login})
 *   return <a href={`/${login}`} {...hovercardAttrs}>{login}</a>
 * }
 * ```
 */
export function useHovercardAttributesForOrganization(
  options: OrganizationHovercardOptions,
): HovercardAttributesResult {
  return useHovercardAttributesBase(organizationHovercardAttributes(options))
}
